export const COMMIT_LIST_HEADER_HEIGHT = 28;
